var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlatzi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1470.34 428.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}.e{fill:#98ca3f;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M165.83,20.12L20.12,165.83c-26.82,26.82-26.82,70.32,0,97.14l145.71,145.71c26.82,26.82,70.32,26.82,97.14,0l48.57-48.57-48.57-48.57-48.57,48.57L68.69,214.4,214.4,68.69l97.14,97.14-97.14,97.14,48.57,48.57,97.14-97.14c26.82-26.82,26.82-70.32,0-97.14L262.97,20.12c-26.82-26.82-70.32-26.82-97.14,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M448.92,361.76V68.69h121.41c65.31,0,103.41,47.73,103.41,103.41s-38.94,101.74-103.41,101.74h-72.43v87.92h-48.98Zm121.41-130.63c33.07,0,56.52-26.38,56.52-60.29s-22.61-59.87-56.52-59.87h-73.27v120.16h73.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M749.78,68.69v220.64c0,33.49,8.79,43.96,43.54,38.52l1.68,35.17c-61.96,10.05-90.43-5.86-90.43-73.27V68.69h45.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1003.83,301.47c0,18.42-.42,30.14,21.77,28.05v30.98c-28.89,5.44-58.61,2.09-58.61-31.4v-8.37c-11.3,28.05-39.77,43.96-69.5,43.96-61.55,0-91.27-49.4-91.27-106.34,1.26-66.99,48.99-103.83,114.72-102.58,28.89,0,56.52,7.12,82.9,18.84v126.86Zm-43.96-100.48c-13.82-6.28-29.31-8.37-42.29-8.37-38.52,0-64.48,22.19-65.73,65.73,0,36.84,18,65.73,55.27,65.73,33.91,0,51.5-26.38,52.75-63.64v-59.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1121.34,160.38h69.92v36.84h-69.92v86.67c0,51.5,32.24,54.85,73.69,40.19l4.61,34.33c-69.08,21.35-123.09,5.44-123.09-73.69v-87.5h-41.03v-36.84h41.03v-49.4h44.8v49.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1219.94,352.55l58.61-91.69,43.96-63.64h-96.29v-37.26h162.03v5.86l-62.38,96.71-41.03,59.87h102.99v39.36h-167.89v-9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1443.13,68.21c13.82,0,27.21,9.21,27.21,26.8s-13.4,27.21-26.8,27.21-28.05-8.79-28.05-27.21,13.82-26.8,27.63-26.8Zm22.61,293.55h-45.64V160.38h45.64v201.38Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatzi);
export default __webpack_public_path__ + "static/media/platzi.52a962eb77d8445b5df37225dd061043.svg";
export { ForwardRef as ReactComponent };